export default __webpack_public_path__ + "6b29e265887d559ac56a621ebaad7b81.png";